import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useParams } from 'react-router-dom';

import EntityPage from 'components/EntityPage';
import {
  fetchEntities,
  createEntity,
  updateEntity,
  archiveEntity,
  entitiesCleanUp,
} from 'state/actions/stationsUsersGroups';
import paths from 'pages/Router/paths';
import { fetchEntities as fetchUsers } from 'state/actions/users';
import { fetchEntities as fetchStations } from 'state/actions/stations';

import EntityProfile from './StationsUsersGroupProfile';
import EntityForm from './StationsUsersGroupForm';
import entitySchema from './schema';

export default () => {
  const entityInfos = {
    i18nEntityName: 'StationsUsersGroup',
    entitiesName: 'stationsUsersGroups',
    entityName: 'stationsUsersGroup',
    PATH_ENTITIES: paths.STATIONS_USERS_GROUPS,
  };
  const entityActions = {
    fetchEntities,
    createEntity,
    updateEntity,
    archiveEntity,
    entitiesCleanUp,
  };

  const { id } = useParams();

  // Create local state
  const [usersInGroup, setUsersInGroup] = useState([]);
  const [stationsInGroup, setStationsInGroup] = useState([]);

  // Get data from store
  const { entity = {}, stations = [], users = [] } = useSelector(
    (state) => ({
      users: state.users.data.sort((a, b) => {
        if (a.name === b.name) {
          return 0;
        }
        if (!!a.name && !b.name) {
          return 1;
        }
        if (!a.name && !!b.name) {
          return -1;
        }
        return a.name > b.name ? 1 : -1;
      }),
      stations: state.stations.data.sort((a, b) => {
        const aSerialNumber = a.serialNumber || '0';

        let aSerialNumberStr = aSerialNumber;
        if (typeof aSerialNumber === 'number') {
          aSerialNumberStr = String(aSerialNumber);
        }
        const aSerialNumberInt = parseInt(aSerialNumberStr.trim(), 10);

        const bSerialNumber = b.serialNumber || '0';
        let bSerialNumberStr = bSerialNumber;
        if (typeof bSerialNumber === 'number') {
          bSerialNumberStr = String(bSerialNumber);
        }
        const bSerialNumberInt = parseInt(bSerialNumberStr.trim(), 10);

        if (aSerialNumberInt === bSerialNumberInt) {
          return 0;
        }
        if (!!aSerialNumberInt && !bSerialNumberInt) {
          return 1;
        }
        if (!aSerialNumberInt && !!bSerialNumberInt) {
          return -1;
        }
        return aSerialNumberInt > bSerialNumberInt ? 1 : -1;
      }),
      entity: state[entityInfos.entitiesName].data.find(
        (_entity) => _entity && _entity.id === id
      ),
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  // Fetch data
  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchStations());
    dispatch(fetchEntities());
  }, [dispatch]);

  // Filter stations and users belonging to this group
  useEffect(() => {
    const { usersIds = [], stationsIds = [] } = entity;
    // Filter users
    if (usersIds.length > 0) {
      const filteredUsers = users.filter((user) => {
        return usersIds.includes(user.id);
      });
      setUsersInGroup(filteredUsers);
    }

    // Filter stations
    if (stationsIds.length > 0) {
      const filteredStations = stations.filter((station) => {
        return stationsIds.includes(station.id);
      });
      setStationsInGroup(filteredStations);
    }
  }, [entity, users, stations]);

  const options = {
    usersInGroup,
    users,
    stationsInGroup,
    stations,
  };

  const { yupSchema } = entitySchema;
  return (
    <EntityPage
      yupSchema={yupSchema}
      entityInfos={entityInfos}
      entityActions={entityActions}
      Profile={EntityProfile}
      Form={EntityForm}
      options={options}
    />
  );
};
